import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { Modal } from "antd";

const AppModal = ({ appName, appIcon, onCancel, destroy }) => {
  return (
    <Modal
      centered
      title={
        <ModalTitle>
          <img src={appIcon} alt="" />
          <div>{appName}</div>
        </ModalTitle>
      }
      open={true}
      onCancel={() => {
        onCancel?.();
        destroy();
      }}
      footer={null}
      width={354}
      style={{ zIndex: 3500 }}
      maskStyle={{ zIndex: 1000 }}
      afterClose={destroy}
    >
      <ModalContent>在应用商店内搜索 “{appName}” 下载安装</ModalContent>
    </Modal>
  );
};

export const showAppModal = (options) => {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const destroy = () => {
    // 卸载组件并移除容器
    ReactDOM.unmountComponentAtNode(container);
    container.parentNode?.removeChild(container);
  };

  // 渲染组件
  ReactDOM.render(<AppModal {...options} destroy={destroy} />, container);

  return destroy; // 返回关闭方法以便手动控制
};

const ModalTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > img {
    margin-top: -42px;
    height: 57px;
  }
  > div {
    margin-top: 6px;
    font-weight: 600;
    font-size: 21px;
    color: #302e47;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }
`;
const ModalContent = styled.div`
  margin-top: 32px;
  margin-bottom: 36px;
  font-weight: 500;
  font-size: 14px;
  color: #2c2e34;
  line-height: 20px;
  text-align: center;
  font-style: normal;
`;
